import { j as A } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as D } from "react";
import { c as L } from "./index-DkZ16bcJ.mjs";
import { l as W } from "./lodash-5ofSKtz3.mjs";
import { b as p, T as g, w as j, c as E } from "./widths.styles-CkAQdON2.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { v as T, m as _ } from "./tss-DN0acMKN.mjs";
import { M as R, d as H } from "./constants-CnFYFetN.mjs";
import { k as N } from "./emotion-react.browser.esm-BdEGsKDn.mjs";
const X = ({ constructs: n, palette: o, mixins: r }, a) => {
  var t, u, i;
  return {
    contained: {
      [`&.MuiButtonGroup-grouped:not(:focus):not(.${a.focusVisible})`]: e.ifFeature(
        "encore",
        {
          borderColor: "transparent"
        },
        {}
      )
    },
    containedPrimary: {
      fill: o.primary.contrastText,
      "&:hover": {
        backgroundColor: e.ifFeature("encore", o.primary.dark, T(o.primary.main, 0.1)),
        color: e.ifFeature("encore", void 0, o.primary.contrastText)
      },
      [`&:active, &.${a.active}`]: {
        backgroundColor: e.ifFeature("encore", o.primary.dark, T(o.primary.main, 0.1)),
        boxShadow: e.ifFeature("encore", void 0, "inset 0 1px 2px 0 rgba(0, 0, 0, 0.15)"),
        "&&": {
          outline: void 0
        }
      },
      [`&&.${a.focusVisible}, &&:focus`]: {
        border: e.ifFeature("encore", `1px solid ${o.primary.lighter}`),
        boxShadow: e.ifFeature(
          "encore",
          `0px 0px 0px 4px ${(t = r.alpha) == null ? void 0 : t.call(r, n.surface.primary.medium, 0.1)}`,
          `${p}, 0 0 0 2px ${(u = r.alpha) == null ? void 0 : u.call(r, o.primary.lightest, 0.35)}`
        )
      },
      [`&.${a.disabled}`]: {
        backgroundColor: e.ifFeature("encore", n.surface.neutral.weak, o.grey[300]),
        boxShadow: e.ifFeature("encore", "none"),
        [`&.${a.processing}`]: {
          backgroundColor: e.ifFeature("encore", "transparent"),
          boxShadow: e.ifFeature("encore", "none", g)
        }
      }
    },
    containedSecondary: {
      fill: e.ifFeature("encore", o.primary.main, o.grey[800]),
      boxShadow: e.ifFeature("encore", void 0, "0 1px rgba(0, 0, 0, 0.03)"),
      backgroundColor: e.ifFeature("encore", o.common.white),
      border: e.ifFeature("encore", `1px solid ${o.primary.main}`),
      color: e.ifFeature("encore", o.primary.main),
      "&:hover": {
        backgroundColor: e.ifFeature("encore", o.primary.lightest, o.grey[300]),
        color: e.ifFeature("encore", void 0, o.grey[900])
      },
      [`&:active, &.${a.active}`]: {
        backgroundColor: e.ifFeature("encore", o.primary.lightest, o.grey[300]),
        boxShadow: e.ifFeature("encore", void 0, "inset 0 1px 2px rgba(0, 0, 0, 0.15)")
      },
      [`&&.${a.focusVisible}, &&:focus`]: {
        border: e.ifFeature("encore", `1px solid ${o.primary.lighter}`),
        boxShadow: e.ifFeature(
          "encore",
          `0px 0px 0px 4px ${(i = r.alpha) == null ? void 0 : i.call(r, n.surface.primary.medium, 0.1)}`,
          `${p}, 0 0 0 2px ${o.grey[400]}`
        )
      },
      [`&.MuiButtonGroup-grouped:not(:focus):not(.${a.focusVisible})`]: e.ifFeature(
        "encore",
        {
          borderColor: o.primary.main
        },
        {}
      ),
      [`&.${a.disabled}`]: {
        backgroundColor: e.ifFeature("encore", n.surface.neutral.weak, o.background.default),
        borderColor: e.ifFeature("encore", "transparent", o.grey[300]),
        boxShadow: e.ifFeature("encore", "none", g),
        fill: e.ifFeature("encore", n.icon.neutral.strong, o.grey[500]),
        [`&.${a.processing}`]: {
          backgroundColor: e.ifFeature("encore", "transparent"),
          borderColor: e.ifFeature("encore", "transparent", o.grey[300]),
          boxShadow: e.ifFeature("encore", "none", g),
          fill: e.ifFeature("encore", n.icon.neutral.strong, o.grey[500])
        }
      }
    }
  };
}, q = ({ palette: n, mixins: o, constructs: r }, a) => {
  var t, u, i;
  return {
    outlined: {
      backgroundColor: e.ifFeature("encore", n.common.white, n.background.default),
      borderColor: e.ifFeature("encore", n.gray[400], n.primary.lighter),
      color: e.ifFeature("encore", n.gray[800]),
      [`&:active, &.${a.active}`]: {
        borderColor: e.ifFeature("encore", r.border.primary.strong),
        backgroundColor: e.ifFeature("encore", n.grey[50], n.background.default),
        fill: e.ifFeature("encore", r.icon.primary.strong),
        "&&.MuiButtonGroup-grouped": e.ifFeature("encore", { borderRightColor: n.gray[700] }, {})
      },
      "&:hover": {
        borderColor: e.ifFeature("encore", n.gray[700]),
        backgroundColor: e.ifFeature("encore", n.common.white, n.background.default)
      }
    },
    outlinedPrimary: {
      borderColor: e.ifFeature("encore", void 0, n.primary.light),
      fill: e.ifFeature("encore", r.text.neutral.strong, n.primary.main),
      "&:hover": {
        borderColor: e.ifFeature("encore", void 0, n.primary.lighter),
        color: e.ifFeature("encore", void 0, n.primary.light),
        fill: e.ifFeature("encore", void 0, n.primary.light),
        boxShadow: e.ifFeature("encore", `box-shadow: 1px 1px 0px 2px ${o.alpha(r.surface.neutral.xxStrong, 0.03)}`)
      },
      [`&:active, &.${a.active}`]: {
        borderColor: e.ifFeature("encore", n.primary.main, n.primary.light),
        boxShadow: e.ifFeature("encore", void 0, "inset 0 1px 1px rgba(0, 0, 0, 0.12)"),
        color: e.ifFeature("encore", n.primary.main),
        fill: e.ifFeature("encore", n.primary.main),
        "&&": {
          outline: e.ifFeature("encore", 0)
        },
        [`&&.MuiButtonGroup-grouped:not(:focus):not(.${a.focusVisible})`]: e.ifFeature(
          "encore",
          {
            borderRightColor: n.primary.main
          },
          {}
        )
      },
      [`&&.${a.focusVisible}, &&:focus`]: {
        borderColor: e.ifFeature("encore", n.primary.lighter, n.primary.light),
        boxShadow: e.ifFeature(
          "encore",
          `0px 0px 0px 4px ${(t = o.alpha) == null ? void 0 : t.call(o, r.surface.primary.medium, 0.1)}`,
          `${p}, 0 0 0 2px ${(u = o.alpha) == null ? void 0 : u.call(o, n.primary.lightest, 0.35)}`
        ),
        "&&.MuiButtonGroup-grouped": e.ifFeature(
          "encore",
          {
            borderRightColor: n.primary.lighter
          },
          {}
        )
      },
      [`&.${a.disabled}`]: {
        backgroundColor: e.ifFeature("encore", r.surface.neutral.weak, n.background.default),
        borderColor: e.ifFeature("encore", "transparent", n.grey[300]),
        boxShadow: e.ifFeature("encore", "none", g),
        fill: e.ifFeature("encore", r.icon.neutral.strong, n.grey[500]),
        [`&.${a.processing}`]: {
          backgroundColor: e.ifFeature("encore", "transparent"),
          borderColor: e.ifFeature("encore", "transparent", n.grey[300]),
          boxShadow: e.ifFeature("encore", "none", g),
          fill: e.ifFeature("encore", r.icon.neutral.strong, n.grey[500])
        }
      }
    },
    outlinedSecondary: {
      borderColor: e.ifFeature("encore", void 0, n.secondary.dark),
      color: e.ifFeature("encore", void 0, n.secondary.contrastText),
      fill: e.ifFeature("encore", void 0, n.grey[800]),
      "&:hover": {
        borderColor: e.ifFeature("encore", void 0, n.secondary.dark),
        color: e.ifFeature("encore", void 0, n.grey[900]),
        fill: e.ifFeature("encore", void 0, n.grey[900]),
        boxShadow: e.ifFeature("encore", `box-shadow: 1px 1px 0px 2px ${o.alpha(r.surface.neutral.xxStrong, 0.03)}`)
      },
      [`&:active, &.${a.active}`]: {
        color: e.ifFeature("encore", n.primary.main),
        fill: e.ifFeature("encore", n.primary.main),
        borderColor: e.ifFeature("encore", void 0, n.secondary.dark),
        boxShadow: e.ifFeature("encore", void 0, "inset 0 1px 1px rgba(0, 0, 0, 0.15)"),
        "&&": {
          outline: e.ifFeature("encore", 0)
        },
        [`&&.MuiButtonGroup-grouped:not(:focus):not(.${a.focusVisible})`]: e.ifFeature(
          "encore",
          {
            borderRightColor: n.secondary.dark
          },
          {}
        )
      },
      [`&&.${a.focusVisible}, &&:focus`]: {
        borderColor: e.ifFeature("encore", n.primary.lighter, n.secondary.dark),
        boxShadow: e.ifFeature(
          "encore",
          `0px 0px 0px 4px ${(i = o.alpha) == null ? void 0 : i.call(o, r.surface.primary.medium, 0.1)}`,
          `${p}, 0 0 0 2px ${n.grey[300]}`
        ),
        outline: e.ifFeature("encore", `1px solid ${n.primary.lighter}`),
        "&&.MuiButtonGroup-grouped": e.ifFeature(
          "encore",
          {
            borderRightColor: n.primary.lighter
          },
          {}
        )
      },
      [`&.${a.disabled}`]: {
        backgroundColor: e.ifFeature("encore", r.surface.neutral.weak, n.background.default),
        borderColor: e.ifFeature("encore", "transparent", n.grey[300]),
        boxShadow: e.ifFeature("encore", "none", g),
        fill: e.ifFeature("encore", r.icon.neutral.strong, n.grey[500]),
        [`&.${a.processing}`]: {
          backgroundColor: e.ifFeature("encore", "transparent"),
          borderColor: e.ifFeature("encore", "transparent", n.grey[300]),
          boxShadow: e.ifFeature("encore", "none", g),
          fill: e.ifFeature("encore", r.icon.neutral.strong, n.grey[500])
        }
      }
    },
    toggled: e.ifFeature(
      "encore",
      {
        backgroundColor: r.surface.neutral.xWeak,
        color: r.text.primary.strong,
        fill: r.icon.primary.strong
      },
      {}
    )
  };
}, J = ({ constructs: n, palette: o, mixins: r }, a) => {
  var t, u, i, c, f, l, b, $, S, m, x, h, y, v, F, C;
  return {
    altStyling: {
      [`&.${a.root}`]: {
        boxShadow: e.ifFeature("encore", `1px 1px 0 1px ${(t = r.alpha) == null ? void 0 : t.call(r, n.surface.neutral.weak, 0.1)}`),
        "&:hover": {
          boxShadow: e.ifFeature("encore", `1px 1px 0 1px ${(u = r.alpha) == null ? void 0 : u.call(r, n.surface.neutral.weak, 0.2)}`)
        },
        [`&:active, &.${a.active}`]: {
          boxShadow: e.ifFeature("encore", `2px 2px 0 1px ${(i = r.alpha) == null ? void 0 : i.call(r, n.surface.neutral.xxStrong, 0.1)}`)
        },
        [`&.${a.focusVisible}, &:focus`]: {
          borderColor: e.ifFeature("encore", o.common.white),
          boxShadow: e.ifFeature("encore", `0 0 0 4px ${(c = r.alpha) == null ? void 0 : c.call(r, n.surface.neutral.strong, 0.4)}`),
          outlineColor: e.ifFeature("encore", o.common.white),
          "&&.MuiButtonGroup-grouped": {
            borderColor: e.ifFeature("encore", o.common.white)
          }
        },
        [`&.${a.disabled}`]: {
          backgroundColor: e.ifFeature("encore", n.surface.neutral.strong, "transparent"),
          borderColor: e.ifFeature("encore", "transparent"),
          boxShadow: e.ifFeature(
            "encore",
            `1px 1px 0 1px ${(f = r.alpha) == null ? void 0 : f.call(r, n.surface.neutral.xxStrong, 0.06)}`,
            "0 1px 1px 0 rgba(0, 0, 0, 0.05)"
          ),
          color: e.ifFeature("encore", n.text.neutral.xStrong, (l = r.alpha) == null ? void 0 : l.call(r, o.common.white, 0.35)),
          fill: e.ifFeature("encore", n.icon.neutral.xxStrong, (b = r.alpha) == null ? void 0 : b.call(r, o.common.white, 0.35))
        },
        [`&.${a.processing}`]: {
          background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(34, 34, 34, 0.2) 50%, rgba(255, 255, 255, 0.1) 100%)",
          backgroundSize: "400% 100%"
        }
      },
      [`&.${a.containedPrimary}`]: {
        backgroundColor: e.ifFeature("encore", o.common.white, o.primary.contrastText),
        border: e.ifFeature("encore", "1px solid transparent"),
        color: o.primary.main,
        fill: o.primary.main,
        "&:hover": {
          backgroundColor: e.ifFeature("encore", o.primary.lightest, o.primary.contrastText)
        },
        [`&:active, &.${a.active}`]: {
          backgroundColor: e.ifFeature("encore", o.primary.lightest, o.primary.contrastText),
          border: e.ifFeature("encore", "1px solid transparent")
        },
        [`&.MuiButtonGroup-grouped:not(:focus):not(.${a.focusVisible})`]: e.ifFeature(
          "encore",
          {
            borderColor: "transparent"
          },
          {}
        ),
        [`&.${a.disabled}`]: {
          backgroundColor: e.ifFeature("encore", n.surface.neutral.strong, "transparent"),
          borderColor: e.ifFeature("encore", "transparent"),
          boxShadow: e.ifFeature(
            "encore",
            `1px 1px 0 1px ${($ = r.alpha) == null ? void 0 : $.call(r, n.surface.neutral.xxStrong, 0.06)}`,
            "0 1px 1px 0 rgba(0, 0, 0, 0.05)"
          ),
          color: e.ifFeature("encore", n.text.neutral.xStrong, (S = r.alpha) == null ? void 0 : S.call(r, o.common.white, 0.35)),
          fill: e.ifFeature("encore", n.icon.neutral.xxStrong, (m = r.alpha) == null ? void 0 : m.call(r, o.common.white, 0.35))
        },
        [`&.${a.processing}`]: {
          [`&:not(.${a.text})`]: {
            background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(34, 34, 34, 0.2) 50%, rgba(255, 255, 255, 0.1) 100%)",
            backgroundSize: "400% 100%"
          }
        }
      },
      ...e.ifFeature(
        "encore",
        {
          [`&.${a.containedSecondary}, &.${a.outlined}`]: {
            backgroundColor: "transparent",
            borderColor: o.common.white,
            color: o.common.white,
            fill: o.common.white,
            "&:hover": {
              backgroundColor: (x = r.alpha) == null ? void 0 : x.call(r, o.common.white, 0.1)
            },
            [`&:active, &.${a.active}`]: {
              backgroundColor: (h = r.alpha) == null ? void 0 : h.call(r, o.common.white, 0.1)
            },
            [`&.${a.focusVisible}, &:focus`]: {
              backgroundColor: (y = r.alpha) == null ? void 0 : y.call(r, o.common.white, 0.1)
            },
            "&&&.MuiButtonGroup-grouped": {
              borderColor: o.common.white
            },
            [`&.${a.disabled}`]: {
              backgroundColor: n.surface.neutral.strong,
              borderColor: "transparent",
              boxShadow: `1px 1px 0 1px ${(v = r.alpha) == null ? void 0 : v.call(r, n.surface.neutral.xxStrong, 0.06)}`,
              color: n.text.neutral.xStrong,
              fill: n.icon.neutral.xxStrong
            },
            [`&.${a.processing}`]: {
              [`&:not(.${a.text})`]: {
                background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(34, 34, 34, 0.2) 50%, rgba(255, 255, 255, 0.1) 100%)",
                backgroundSize: "400% 100%"
              }
            }
          }
        },
        // Jade styles
        {
          [`&.${a.containedPrimary}, &.${a.containedSecondary}`]: {
            backgroundColor: o.primary.contrastText,
            color: o.primary.main,
            fill: o.primary.main,
            "&:hover": {
              backgroundColor: o.primary.contrastText,
              color: o.primary.lighter,
              fill: o.primary.lighter
            },
            [`&:active, &.${a.active}`]: {
              backgroundColor: o.primary.contrastText,
              boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.25)"
            },
            [`&.${a.focusVisible}, &:focus`]: {
              boxShadow: `${p}, 0 0 0 2px ${o.primary.lighter}`
            },
            [`&.${a.disabled}`]: {
              backgroundColor: "transparent",
              borderColor: (F = r.alpha) == null ? void 0 : F.call(r, o.common.white, 0.5),
              boxShadow: g
            }
          },
          [`&.${a.outlined}`]: {
            backgroundColor: "transparent",
            borderColor: o.grey[200],
            boxShadow: p,
            color: o.grey[200],
            fill: o.grey[200],
            "&:hover": {
              backgroundColor: "transparent",
              borderColor: o.background.default,
              color: o.background.default,
              fill: o.background.default
            },
            [`&:active, &.${a.active}`]: {
              borderColor: o.background.default,
              boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.15)"
            },
            [`&.${a.focusVisible}, &:focus`]: {
              borderColor: o.background.default,
              boxShadow: `${p}, 0 0 0 2px rgba(255, 255, 255, 0.25)`
            },
            [`&.${a.disabled}`]: {
              borderColor: (C = r.alpha) == null ? void 0 : C.call(r, o.background.default, 0.35),
              boxShadow: g
            }
          }
        }
      )
    }
  };
}, K = (n, o) => {
  var a, t, u, i, c;
  const { typography: r } = n;
  return {
    sizeMedium: {
      "&&": {
        padding: e.ifFeature("encore", "0 16px", void 0),
        minWidth: e.ifFeature("encore", "48px", void 0)
      },
      [`&.${o.noBoundingBox}, &.${o.hoverOnly}`]: {
        padding: e.ifFeature("encore", "0", void 0),
        minWidth: e.ifFeature("encore", "0", void 0)
      },
      [`&.${o.hoverOnly}`]: {
        padding: e.ifFeature("encore", "0", void 0),
        minWidth: e.ifFeature("encore", "0", void 0)
      }
    },
    sizeTeenie: {
      height: "28px",
      fontSize: e.ifFeature("encore", r.small.fontSize, (a = r.fabricFontSize) == null ? void 0 : a.call(r, "teenie")),
      padding: e.ifFeature("encore", void 0, "0 11px"),
      [`&.${o.iconOnly}`]: {
        padding: "0 7px"
      },
      "&&": {
        padding: e.ifFeature("encore", "8px 12px", void 0),
        minWidth: e.ifFeature("encore", "36px", void 0)
      },
      [`&.${o.noBoundingBox}, &.${o.hoverOnly}`]: {
        height: e.ifFeature("encore", "unset"),
        padding: e.ifFeature("encore", "0", void 0),
        minWidth: e.ifFeature("encore", "0", void 0)
      }
    },
    "sizeExtra-small": {
      padding: e.ifFeature("encore", "0 12px", "0 11px"),
      height: "28px",
      fontSize: e.ifFeature("encore", "13px", (t = r.fabricFontSize) == null ? void 0 : t.call(r, "teenie")),
      minWidth: e.ifFeature("encore", "36px"),
      [`&.${o.iconOnly}`]: {
        minWidth: e.ifFeature("encore", "36px"),
        padding: "0 12px"
      },
      [`&.${o.noBoundingBox}, &.${o.hoverOnly}`]: {
        height: e.ifFeature("encore", "unset"),
        padding: e.ifFeature("encore", "0"),
        minWidth: e.ifFeature("encore", "0")
      }
    },
    sizeSmall: {
      height: "32px",
      fontSize: e.ifFeature("encore", r.small.fontSize, (u = r.fabricFontSize) == null ? void 0 : u.call(r, "small")),
      padding: e.ifFeature("encore", void 0, "0 11px"),
      "&&": {
        padding: e.ifFeature("encore", "0 12px", void 0),
        minWidth: e.ifFeature("encore", "40px", void 0)
      },
      [`&.${o.noBoundingBox}, &.${o.hoverOnly}`]: {
        height: e.ifFeature("encore", "unset"),
        padding: e.ifFeature("encore", "0", void 0),
        minWidth: e.ifFeature("encore", "0", void 0)
      }
    },
    sizeLarge: {
      height: e.ifFeature("encore", "48px", "36px"),
      fontSize: e.ifFeature("encore", r.large.fontSize, (i = r.fabricFontSize) == null ? void 0 : i.call(r, "large")),
      "&&": {
        padding: e.ifFeature("encore", "0 20px", void 0),
        minWidth: e.ifFeature("encore", "48px", void 0)
      },
      [`&.${o.noBoundingBox}, &.${o.hoverOnly}`]: {
        height: e.ifFeature("encore", "unset"),
        padding: e.ifFeature("encore", "0", void 0),
        minWidth: e.ifFeature("encore", "0", void 0)
      }
    },
    sizeBiggie: {
      fontSize: e.ifFeature("encore", r.large.fontSize, (c = r.fabricFontSize) == null ? void 0 : c.call(r, "biggie")),
      minWidth: e.ifFeature("encore", "48px"),
      "&&": {
        padding: e.ifFeature("encore", "0 20px", "0 15px"),
        height: e.ifFeature("encore", "48px", "42px")
      },
      [`&.${o.iconOnly}`]: {
        padding: e.ifFeature("encore", "0 20px", "0 15px")
      },
      [`&.${o.noBoundingBox}, &.${o.hoverOnly}`]: {
        height: e.ifFeature("encore", "unset"),
        padding: e.ifFeature("encore", "0", void 0),
        minWidth: e.ifFeature("encore", "0", void 0)
      }
    },
    sizeHuge: {
      [`&.${o.noBoundingBox}, &.${o.hoverOnly}`]: {
        padding: e.ifFeature("encore", "0", void 0),
        minWidth: e.ifFeature("encore", "0", void 0)
      }
    }
  };
}, Q = (n, o, r) => {
  var c, f;
  const { borderRadiuses: a, palette: t, mixins: u, constructs: i } = n;
  return {
    active: {},
    altStyling: {},
    focusVisible: {},
    endIcon: {},
    disabled: {
      [`&.${r.floatingIcon}`]: {
        backgroundColor: e.ifFeature("encore", i.surface.neutral.weak),
        borderColor: "transparent",
        boxShadow: e.ifFeature("encore", "none", "0 1px 0 0 rgba(0, 0, 0, 0)")
      },
      [`&.${r.noBoundingBox}`]: {
        backgroundColor: e.ifFeature("encore", "transparent"),
        fill: e.ifFeature("encore", t.gray[500])
      }
    },
    processing: {
      [`&.${r.floatingIcon}`]: {
        backgroundColor: e.ifFeature("encore", i.surface.neutral.forcedWhite),
        borderColor: e.ifFeature("encore", void 0, t.gray[300])
      }
    },
    floatingIcon: {
      // This inclues the styles for the floatingIcon button classes, including overrides for the states and dark styles
      backgroundColor: "transparent",
      borderColor: "transparent",
      boxShadow: e.ifFeature("encore", "none", "0 1px 0 0 rgba(0, 0, 0, 0)"),
      verticalAlign: e.ifFeature("encore", void 0, "unset"),
      fill: e.ifFeature("encore", void 0, t.primary.main),
      // GOTCHA: Adding the `hover` boxShadow here will override `active` and `focus` boxShadow styles on `outlinedPrimary` and `outlinedSecondary` button classes due to specificity. For this reason, we must reinclude the `outlinedPrimary` and `outlinedSecondary` active and focus styles at this level.
      "&:hover": {
        backgroundColor: e.ifFeature("encore", i.surface.neutral.forcedWhite, t.primary.contrastText),
        boxShadow: e.ifFeature("encore", void 0, "0 1px 0 0 rgba(0, 0, 0, 0.05)")
      },
      [`&:focus, &.${r.focusVisible}`]: {
        backgroundColor: e.ifFeature("encore", i.surface.neutral.forcedWhite),
        borderColor: e.ifFeature("encore", void 0, t.primary.main)
      },
      [`&.${r.outlinedPrimary}`]: {
        [`&:active, &.${r.active}`]: {
          boxShadow: e.ifFeature("encore", void 0, "inset 0 1px 1px rgba(0, 0, 0, 0.12)"),
          borderColor: e.ifFeature("encore", void 0, t.primary.main)
        },
        [`&.${r.focusVisible}`]: {
          boxShadow: e.ifFeature(
            "encore",
            void 0,
            `0 1px 0 0 rgba(0, 0, 0, 0.05), 0 0 0 2px ${(c = u.alpha) == null ? void 0 : c.call(u, t.primary.lightest, 0.35)}`
          )
        },
        [`& .${r.disabled}`]: {
          borderColor: e.ifFeature("encore", "transparent")
        }
      },
      [`&.${r.outlinedSecondary}`]: {
        [`&:active, &.${r.active}`]: {
          boxShadow: e.ifFeature("encore", void 0, "inset 0 1px 1px rgba(0, 0, 0, 0.15)"),
          borderColor: e.ifFeature("encore", void 0, t.primary.main)
        },
        [`&.${r.focusVisible}`]: {
          boxShadow: e.ifFeature("encore", void 0, `0 1px 0 0 rgba(0, 0, 0, 0.05), 0 0 0 2px ${t.gray[300]}`)
        }
      },
      [`&.${r.disabled}`]: {
        // This is the disabled floatingIcon styles
        backgroundColor: e.ifFeature("encore", i.surface.neutral.weak),
        fill: e.ifFeature("encore", i.icon.neutral.strong),
        [`&&.${r.focusVisible}, &&:focus`]: {
          fill: e.ifFeature("encore", i.icon.neutral.strong),
          "&:after": {
            boxShadow: "none"
          }
        }
      },
      [`&.${r.altStyling}`]: {
        // This is the floatingIcon dark styles
        borderColor: "transparent",
        boxShadow: e.ifFeature("encore", "none", "0 1px 0 0 rgba(0, 0, 0, 0)"),
        "&:hover": {
          backgroundColor: e.ifFeature("encore", void 0, "transparent"),
          boxShadow: e.ifFeature("encore", void 0, "0 2px 2px 0 rgba(0, 0, 0, 0.15)")
        },
        [`&.${r.active}, &:active`]: {
          borderColor: e.ifFeature("encore", void 0, t.primary.contrastText)
        },
        [`&.${r.disabled}`]: {
          // This is the dark disabled floatingIcon styles
          fill: e.ifFeature("encore", i.text.neutral.xStrong),
          [`&&.${r.focusVisible}, &&:focus`]: {
            fill: e.ifFeature("encore", i.text.neutral.xStrong)
          }
        }
      }
    },
    noBoundingBox: {
      // This inclues the styles for the noBoundingBox button classes, including overrides for the states and dark styles
      backgroundColor: e.ifFeature("encore", void 0, "transparent"),
      fill: t.gray[600],
      verticalAlign: e.ifFeature("encore", void 0, "unset"),
      border: e.ifFeature("encore", "none"),
      height: "unset",
      boxShadow: "none",
      padding: e.ifFeature("encore", void 0, 0),
      "&:hover": {
        backgroundColor: "transparent",
        boxShadow: e.ifFeature("encore", "none"),
        fill: e.ifFeature("encore", t.gray[900], t.gray[800])
      },
      [`&.${r.altStyling}`]: {
        // This is the dark styles for the noBoundingBox button classes
        boxShadow: e.ifFeature("encore", "none", "0 1px 0 0 rgba(0, 0, 0, 0)"),
        fill: e.ifFeature("encore", i.icon.neutral.inverted, (f = u.alpha) == null ? void 0 : f.call(u, t.primary.contrastText, 0.7)),
        "&:hover": {
          boxShadow: e.ifFeature("encore", "none", "0 1px 0 0 rgba(0, 0, 0, 0)"),
          fill: e.ifFeature("encore", "none", t.primary.contrastText),
          ":after": {
            boxShadow: e.ifFeature(
              "encore",
              `0px 0px 0px 2px ${u.alpha(i.surface.neutral.inverted, 0.3)}`,
              "none"
            ),
            borderRadius: e.ifFeature("encore", "8px"),
            content: '""',
            position: "absolute",
            left: "-8px",
            top: "-4px",
            right: "-8px",
            bottom: "-4px"
          }
        },
        [`&&.${r.focusVisible}, &:focus`]: {
          fill: e.ifFeature("encore", i.icon.neutral.inverted, t.primary.contrastText),
          boxShadow: e.ifFeature("encore", void 0, "none"),
          ":after": {
            boxShadow: e.ifFeature("encore", `0px 0px 0px 2px ${u.alpha(i.surface.neutral.inverted, 0.8)}`)
          },
          textDecoration: "none"
        },
        [`&.${r.disabled}`]: {
          // This is the dark disabled noBoundingBox styles
          fill: e.ifFeature("encore", i.icon.neutral.medium),
          backgroundColor: e.ifFeature("encore", "transparent"),
          [`&&.${r.focusVisible}, &&:focus`]: {
            fill: e.ifFeature("encore", i.icon.neutral.medium)
          },
          ":after": {
            content: "unset"
          }
        }
      },
      [`&.${r.active}, &:active`]: {
        boxShadow: "none !important",
        fill: e.ifFeature("encore", t.gray[900], t.primary.contrastText),
        [`&&.${r.focusVisible}, &&:focus`]: {
          ":after": {
            content: e.ifFeature("encore", "unset")
          }
        }
      },
      [`&&.${r.focusVisible}, &&:focus`]: e.ifFeature(
        "encore",
        {
          fill: t.gray[800],
          border: "none",
          boxShadow: "none",
          outline: "none",
          ":after": {
            boxShadow: `0px 0px 0px 2px ${u.alpha(i.surface.primary.medium, 0.8)}`,
            borderRadius: "4px",
            content: '""',
            position: "absolute",
            left: "-2px",
            top: "-2px",
            right: "-2px",
            bottom: "-2px"
          }
        },
        {
          boxShadow: `0px 0px 0px 2px ${t.primary.lightest}`
        }
      ),
      [`&.${r.disabled}`]: {
        // This is the disabled noBoundingBox styles
        backgroundColor: "transparent",
        fill: e.ifFeature("encore", i.icon.neutral.strong),
        [`&&.${r.focusVisible}, &&:focus`]: {
          fill: e.ifFeature("encore", i.icon.neutral.strong),
          "&:after": {
            boxShadow: "none"
          }
        },
        [`&.${r.processing}`]: {
          background: e.ifFeature("encore", "transparent")
        }
      }
    },
    hoverOnly: {
      // This inclues the styles for the hoverOnly button classes, including overrides for the states and dark styles
      backgroundColor: e.ifFeature("encore", "none", "transparent"),
      boxShadow: "none !important",
      cursor: e.ifFeature("encore", void 0, "default"),
      fill: t.gray[600],
      height: "unset",
      verticalAlign: e.ifFeature("encore", void 0, "unset"),
      padding: e.ifFeature("encore", void 0, 0),
      [`.${r.iconOnly}`]: {
        padding: e.ifFeature("encore", void 0, "0 11px")
      },
      "&:hover": {
        backgroundColor: "transparent",
        boxShadow: "none !important",
        fill: t.primary.main,
        [`&&.${r.focusVisible}, &&:focus`]: {
          ":after": {
            content: e.ifFeature("encore", "unset")
          }
        }
      },
      [`&&.${r.focusVisible}, &&:focus`]: {
        borderColor: "transparent",
        boxShadow: "none",
        fill: e.ifFeature("encore", i.icon.primary.strong),
        outline: "none",
        ":after": e.ifFeature("encore", {
          content: '""',
          position: "absolute",
          left: "-8px",
          top: "-4px",
          right: "-8px",
          bottom: "-4px",
          boxShadow: `0px 0px 0px 2px ${u.alpha(i.surface.primary.medium, 0.8)}`,
          borderRadius: a[200]
        })
      },
      [`&.${r.focusVisible}`]: {
        boxShadow: e.ifFeature("encore", void 0, "none"),
        fill: t.primary.main,
        outline: "none"
      },
      [`&:active, &.${r.active}`]: {
        boxShadow: "none !important",
        fill: e.ifFeature("encore", i.icon.primary.strong, t.primary.main),
        [`&&.${r.focusVisible}, &&:focus`]: {
          ":after": {
            content: e.ifFeature("encore", "unset")
          }
        }
      },
      [`&.${r.altStyling}`]: {
        // This is the dark styles for the hoverOnly button classes
        boxShadow: e.ifFeature("encore", void 0, "0 1px 0 0 rgba(0, 0, 0, 0)"),
        fill: e.ifFeature("encore", i.icon.neutral.inverted, t.primary.contrastText),
        [`&&.${r.focusVisible}, &:focus`]: {
          fill: e.ifFeature("encore", i.icon.neutral.inverted, t.primary.contrastText),
          ":after": {
            boxShadow: e.ifFeature("encore", `0px 0px 0px 2px ${u.alpha(i.surface.neutral.inverted, 0.8)}`),
            borderRadius: e.ifFeature("encore", "8px"),
            content: '""',
            position: "absolute",
            left: "-8px",
            top: "-4px",
            right: "-8px",
            bottom: "-4px"
          },
          textDecoration: "none"
        },
        "&:hover": {
          boxShadow: e.ifFeature("encore", "none", "0 1px 0 0 rgba(0, 0, 0, 0)"),
          fill: e.ifFeature("encore", t.primary.main, t.primary.contrastText),
          ":after": {
            boxShadow: e.ifFeature(
              "encore",
              `0px 0px 0px 2px ${u.alpha(i.surface.neutral.inverted, 0.3)}`,
              "none"
            ),
            borderRadius: e.ifFeature("encore", "8px"),
            content: '""',
            position: "absolute",
            left: "-8px",
            top: "-4px",
            right: "-8px",
            bottom: "-4px"
          }
        },
        [`&.${r.disabled}`]: {
          // This is the dark disabled hoverOnly styles
          fill: e.ifFeature("encore", i.icon.neutral.medium),
          backgroundColor: e.ifFeature("encore", "transparent"),
          [`&&.${r.focusVisible}, &&:focus`]: {
            fill: e.ifFeature("encore", i.icon.neutral.medium)
          },
          ":after": {
            content: "unset"
          }
        }
      },
      [`&.${r.disabled}`]: {
        // This is the disabled hoverOnly styles
        backgroundColor: "transparent",
        fill: e.ifFeature("encore", i.icon.neutral.strong),
        [`&&.${r.focusVisible}, &&:focus`]: {
          fill: e.ifFeature("encore", i.icon.neutral.strong),
          "&:after": {
            boxShadow: "none"
          }
        },
        [`&.${r.processing}`]: {
          background: e.ifFeature("encore", "transparent")
        }
      }
    },
    ...K(n, r)
  };
}, U = _({ name: "IconButton" })((n, o, r) => {
  var b;
  const { constructs: a, mixins: t, palette: u, transitions: i, typography: c, mode: f } = n, l = { duration: 200, easing: "ease" };
  return {
    root: {
      border: "1px solid transparent",
      borderRadius: e.ifFeature("encore", 100, 2),
      boxShadow: e.ifFeature(
        "encore",
        `1px 1px 0px 1px ${t.alpha(a.surface.neutral.xxStrong, 0.03)}`,
        p
      ),
      fontSize: e.ifFeature("encore", c.medium.fontSize, (b = c.fabricFontSize) == null ? void 0 : b.call(c, "medium")),
      fontWeight: e.ifFeature("encore", c.fontWeightSemibold, c.fontWeightHeavy),
      height: e.ifFeature("encore", "40px", "34px"),
      outline: f === R.Dye ? `1px solid ${H.main}` : void 0,
      padding: e.ifFeature("encore", "0 20px", "0 15px"),
      textTransform: e.ifFeature("encore", "none"),
      transition: i.create(
        ["background-color", "border", "borderColor", "box-shadow", "color", "fill"],
        l
      ),
      verticalAlign: "bottom",
      [`&&.${r.focusVisible}, &&:focus`]: {
        border: e.ifFeature("encore", `1px solid ${u.primary.lighter}`),
        boxShadow: e.ifFeature("encore", `0px 0px 0px 4px ${a.surface.primary.weak}`),
        outline: e.ifFeature("encore", `1px solid ${u.primary.lighter}`),
        "&&.MuiButtonGroup-grouped": e.ifFeature(
          "encore",
          {
            borderRightColor: u.primary.lighter,
            zIndex: 3
          },
          {
            zIndex: 2
          }
        )
      },
      [`&&:active, &&.${r.active}`]: {
        "&&": {
          boxShadow: e.ifFeature("encore", `2px 2px 0px 1px ${t.alpha(a.surface.neutral.xxStrong, 0.1)} inset`),
          outline: f === R.Dye ? void 0 : 0
        },
        outline: e.ifFeature("encore", 0),
        "&.MuiButtonGroup-grouped": e.ifFeature(
          "encore",
          {
            zIndex: 2
          },
          {}
        )
      },
      "&:hover": {
        boxShadow: e.ifFeature(
          "encore",
          `1px 1px 0px 2px ${t.alpha(a.surface.neutral.xxStrong, 0.03)}`,
          "0 2px 2px 0 rgba(0, 0, 0, 0.1)"
        ),
        "&.MuiButtonGroup-grouped": e.ifFeature(
          "encore",
          {
            zIndex: 2
          },
          {}
        )
      },
      // Need to add disabled styles here for added specificity
      [`&.${r.disabled}`]: {
        backgroundColor: e.ifFeature("encore", u.grey[200], u.common.white),
        border: e.ifFeature("encore", "1px solid transparent", `1px solid ${u.grey[300]}`),
        boxShadow: e.ifFeature("encore", void 0, g),
        color: e.ifFeature("encore", u.grey[600], u.grey[500]),
        cursor: "default",
        fill: e.ifFeature("encore", u.grey[600], u.grey[500]),
        [`&&:active, &&.${r.active}`]: {
          "&&": {
            boxShadow: e.ifFeature("encore", "none")
          }
        },
        [`&&.${r.focusVisible}, &&:focus`]: {
          borderColor: e.ifFeature("encore", "transparent"),
          boxShadow: e.ifFeature("encore", "none"),
          outline: e.ifFeature("encore", "none")
        }
      },
      [`&:not(.MuiButtonGroup-grouped) + &:not(.${r.noSpacing})`]: {
        marginLeft: e.ifFeature("encore", void 0, "12px")
      },
      // counter browser anchor styles
      "a&": {
        outlineOffset: 0
      }
    },
    iconOnly: {
      padding: e.ifFeature("encore", void 0, "0 11px")
    },
    ...X(n, r),
    ...q(n, r),
    ...Q(n, o, r),
    ...J(n, r),
    ...j,
    noSpacing: {
      marginLeft: 0
    },
    /**
     * Button state styles
     */
    active: {},
    disabled: {},
    focusVisible: {},
    processing: {
      [`&:not(.${r.text})`]: {
        animation: `${N`
					0% { 
						background-position: 0 0; 
					}
					100% { 
						background-position: 133% 0; 
					}`} 1.5s linear infinite reverse`,
        background: "linear-gradient(90deg, transparent 0%, rgba(173, 173, 173, 0.2) 50%, transparent 100%)",
        backgroundSize: "400% 100%"
      }
    },
    /**
     * Child component styles
     */
    label: {
      alignItems: "center",
      display: "flex",
      height: "inherit",
      overflow: "hidden"
    },
    alignContentLeft: {
      justifyContent: "flex-start"
    },
    alignContentRight: {
      justifyContent: "flex-end"
    },
    content: {
      display: "flex"
    }
  };
}), we = D((n, o) => {
  const {
    active: r,
    biId: a,
    classes: t,
    component: u,
    dark: i,
    floatingIcon: c,
    focused: f,
    hoverOnly: l,
    noBoundingBox: b,
    onClick: $,
    variant: S,
    // deprecated props below
    clickAction: m,
    isActive: x,
    isFocused: h,
    hasBounding: y,
    size: v = "medium",
    ...F
  } = n, { width: C, processing: P, isProcessing: I, noSpacing: B, alignContent: V, icon: M } = n, { classes: d } = U(void 0, { props: { classes: t } }), z = r || x, O = f || h, w = W.isBoolean(y) ? !y : b;
  let k = S;
  w || l ? k = "text" : c && (k = "outlined");
  const {
    // Destructuring Classes from useStyles so that we can apply the rest of the classes at the end of the styles (needed for classes like content)
    root: Y,
    active: Z,
    focusVisible: s,
    alignContentLeft: ee,
    alignContentRight: re,
    altStyling: oe,
    disabled: ne,
    contained: ae,
    containedPrimary: ie,
    containedSecondary: te,
    outlined: ue,
    outlinedPrimary: de,
    outlinedSecondary: ce,
    text: fe,
    textOnly: le,
    iconOnly: ge,
    textPrimary: pe,
    textSecondary: be,
    ...G
  } = d;
  return /* @__PURE__ */ A.jsx(
    E,
    {
      active: z,
      classes: {
        root: L(d.root, d[`size${W.capitalize(v)}`], d[`width${String(C)}`], {
          [d.active]: z || x,
          [d.focusVisible]: O || h,
          [d.processing]: P || I,
          [d.noSpacing]: B || e.ifFeature("encore", !0, B),
          [d.iconOnly]: !!M,
          [d.altStyling]: i,
          [d.alignContentLeft]: V === "left",
          [d.alignContentRight]: V === "right",
          [d.floatingIcon]: c && !w && !l,
          [d.noBoundingBox]: w,
          [d.hoverOnly]: l,
          [d.altStyling]: i
        }),
        disabled: d.disabled,
        focusVisible: d.focusVisible,
        contained: d.contained,
        containedPrimary: d.containedPrimary,
        containedSecondary: d.containedSecondary,
        outlined: d.outlined,
        outlinedPrimary: d.outlinedPrimary,
        outlinedSecondary: d.outlinedSecondary,
        ...G
      },
      component: l ? u || "div" : u,
      dark: i,
      "data-bi-id": a,
      focused: O,
      onClick: l ? void 0 : $ || m,
      ref: o,
      size: v,
      ...F,
      "data-fabric-component": F["data-fabric-component"] ? `${F["data-fabric-component"]} IconButton` : "IconButton",
      variant: k
    }
  );
});
export {
  we as I
};
//# sourceMappingURL=icon-button-BxDvkq_l.mjs.map
